export const IconButtonStyle = ({ theme }) => ({
  borderRadius: '100%',
  backgroundColor: theme.palette.background.grey.light,
  '&:hover': {
    backgroundColor: theme.palette.background.grey.darker
  },
  '&:focus': {
    outline: `5px solid ${theme.palette.background.blue.main}`
  }
});
